/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInboundAttachmentRequest } from '../models/AcceptInboundAttachmentRequest';
import type { BulkAcceptInboundAttachmentRequest } from '../models/BulkAcceptInboundAttachmentRequest';
import type { BulkIgnoreInboundAttachmentRequest } from '../models/BulkIgnoreInboundAttachmentRequest';
import type { FileWithUrl_Output } from '../models/FileWithUrl_Output';
import type { IgnoreInboundAttachmentRequest } from '../models/IgnoreInboundAttachmentRequest';
import type { InboundEmailAttachmentRead } from '../models/InboundEmailAttachmentRead';
import type { InboundEmailInboxFilter } from '../models/InboundEmailInboxFilter';
import type { InboundEmailInboxResponse } from '../models/InboundEmailInboxResponse';
import type { InboundEmailPendingCountResponse } from '../models/InboundEmailPendingCountResponse';
import type { StaffInboundEmailInboxResponse } from '../models/StaffInboundEmailInboxResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InboundEmailService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Inbox For All Clusters
     * @param statusFilter
     * @returns StaffInboundEmailInboxResponse Successful Response
     * @throws ApiError
     */
    public listInboxForAllClusters(
        statusFilter: InboundEmailInboxFilter,
    ): CancelablePromise<StaffInboundEmailInboxResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/inbound-emails/list-inbox-for-all-clusters',
            query: {
                'status_filter': statusFilter,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Inbox For Cluster
     * @param clusterId
     * @param statusFilter
     * @returns InboundEmailInboxResponse Successful Response
     * @throws ApiError
     */
    public listInboxForCluster(
        clusterId: string,
        statusFilter: InboundEmailInboxFilter,
    ): CancelablePromise<InboundEmailInboxResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/inbound-emails',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'status_filter': statusFilter,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Count Pending For Cluster
     * @param clusterId
     * @returns InboundEmailPendingCountResponse Successful Response
     * @throws ApiError
     */
    public countPendingForCluster(
        clusterId: string,
    ): CancelablePromise<InboundEmailPendingCountResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/inbound-emails/pending-count',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Accept Attachments For Cluster
     * @param clusterId
     * @param requestBody
     * @returns InboundEmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public bulkAcceptAttachmentsForCluster(
        clusterId: string,
        requestBody: BulkAcceptInboundAttachmentRequest,
    ): CancelablePromise<Array<InboundEmailAttachmentRead>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/inbound-emails/bulk-accept',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Ignore Attachments For Cluster
     * @param clusterId
     * @param requestBody
     * @returns InboundEmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public bulkIgnoreAttachmentsForCluster(
        clusterId: string,
        requestBody: BulkIgnoreInboundAttachmentRequest,
    ): CancelablePromise<Array<InboundEmailAttachmentRead>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/inbound-emails/bulk-ignore',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Attachment Download Url For Cluster
     * @param clusterId
     * @param attachmentId
     * @returns FileWithUrl_Output Successful Response
     * @throws ApiError
     */
    public getAttachmentDownloadUrlForCluster(
        clusterId: string,
        attachmentId: string,
    ): CancelablePromise<FileWithUrl_Output> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/inbound-emails/attachments/{attachment_id}/download-url',
            path: {
                'cluster_id': clusterId,
                'attachment_id': attachmentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Accept Attachment For Cluster
     * @param clusterId
     * @param attachmentId
     * @param requestBody
     * @returns InboundEmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public acceptAttachmentForCluster(
        clusterId: string,
        attachmentId: string,
        requestBody: AcceptInboundAttachmentRequest,
    ): CancelablePromise<InboundEmailAttachmentRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/inbound-emails/attachments/{attachment_id}/accept',
            path: {
                'cluster_id': clusterId,
                'attachment_id': attachmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Ignore Attachment For Cluster
     * @param clusterId
     * @param attachmentId
     * @param requestBody
     * @returns InboundEmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public ignoreAttachmentForCluster(
        clusterId: string,
        attachmentId: string,
        requestBody: IgnoreInboundAttachmentRequest,
    ): CancelablePromise<InboundEmailAttachmentRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/inbound-emails/attachments/{attachment_id}/ignore',
            path: {
                'cluster_id': clusterId,
                'attachment_id': attachmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
